import styled from "styled-components";

export const PressureWrapper = styled.div`
  padding: 24px;
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0px 2px 12px rgba(0,0,0,0.05);
`;

export const TitleContainer = styled.div`
  margin-bottom: 8px;

  h3 {
    font-size: 20px;
    font-weight: 600;
  }
`;

export const InfoContainer = styled.div`
  margin-bottom: 24px;

  p {
    color: rgba(32, 32, 32, 0.7);
    font-size: 14px;
  }
`;

export const DividerWithText = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    cursor: pointer;
    margin: 24px 0;

    .line {
        width: 100%;
        border-top: 1px solid #00aaff;
        margin: 20px 0;
    }

    .text {
        color: #00aaff;
        font-weight: 600;
        font-size: 14px;
        text-align: center;
        padding: 4px 12px;
        background: white;
        border-radius: 4px;
    }

`;

export const AccordionPlaceholder = styled.div`
  color: rgba(32, 32, 32, 0.7);
  font-size: 12px;
  line-height: 16px;
  font-weight: 400;
  padding-right:12px;
`;

export const PaginationWrapper = styled.div`
  margin-top: 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const Divider = styled.div`
  height: 37px;
  width: 2px;
  background: rgba(32, 32, 32, 0.1);

  `;

  export const SpecieParameterToggleWrapper = styled.div`
  display: flex;
  align-items: center;
  font-size: 14px;
  font-weight: 400;
  line-height: 16px;
  color: ${(p) => {
    return p.isActive ? 'rgba(10, 161, 244, 1)' : 'rgba(32, 32, 32, 0.7)'
  }};
  gap: 8px;

  path {
    fill: ${(p) => {
    return p.isActive ? 'rgba(10, 161, 244, 1)' : 'rgba(32, 32, 32)'
  }};
    fill-opacity: ${(p) => {
    return p.isActive ? '1' : '0.5'
  }};
  }

  :hover {
    color: rgba(10, 161, 244, 1);

    path {
      fill-opacity: 1;
      fill: rgba(10, 161, 244, 1);
    }
  }
`

export const SpeciesDetailsContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  padding: ${(p) => {
    return p.noPadding ? '0px' : '0px 112px'
  }};
`

export const StateFormContainer = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding: 0px 112px;
`;

export const StateFormItemWrapper = styled.div`
  width: 416px;
  margin-bottom: 10px;
`;

export const HeaderActionsWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  justify-content: flex-end;
`;

const iconType = ({ type }) => {
  if (type === 'confirmed') {
    return css`
      background-color: rgba(5, 148, 79, 0.1);

      path {
        fill-opacity: 1;
        fill: rgba(5, 148, 79, 1);
      }
    `
  } else if (type === 'rejected') {
    return css`
      background-color: rgba(225, 25, 0, 0.1);

      path {
        fill-opacity: 1;
        fill: rgba(225, 25, 0, 1);
      }
    `
  }
}

export const EcosystemHeaderNavbarWrapper = styled.div`
  width: 100%;
  border-top: 1px solid rgba(32, 32, 32, 0.2);
  border-bottom: ${(p) => {
    return p.bottomBorder ? '1px solid rgba(32, 32, 32, 0.2)' : 'none'
  }};
  &:last-child {
    border-bottom: 1px solid rgba(32, 32, 32, 0.2);
  }
  min-height: 56px;
  height: 56px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  flex-wrap: nowrap;
  margin-bottom: ${(p) => {
    return p.isOpen ? '48px' : '0px'
  }};

  button {
    white-space: nowrap;
    box-sizing: border-box;
    flex-shrink: 0;
  }
`

export const EcosystemHeaderNavbarHalfSide = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  // cursor: pointer;
  position: relative
`

export const EcosystemHeaderIconWrapper = styled.div`
  height: 20px;
  width: 20px;
  flex-shrink: 0;
  display: grid;
  place-items: center;
`

export const EcosystemHeaderIcon = styled.div`
  height: 8px;
  width: 8px;
  border-radius: 50%;
  background: ${(p) => {
    return p.isRejected ? '#008000' : '#0aa1f4'
  }};
`

export const EcosystemHeaderTitle = styled.div`
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  height: auto;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  min-width: 0;
  flex: 1;
  margin-left: 16px;
  color: ${(p) => {
    return p.isRejected ? 'rgba(32, 32, 32, 0.5)' : 'rgba(32, 32, 32, 1)'
  }};
`

export const EcosystemHeaderNavbarIconWrapper = styled.div`
  height: 32px;
  width: 32px;
  border-radius: 4px;
  display: grid;
  place-items: center;
  user-select: none;
  cursor: pointer;
  margin-left: 16px;

  :hover {
    background: rgba(225, 25, 0, 0.05);

    path {
      fill-opacity: 1;
      fill: rgba(225, 25, 0, 1);
    }
  }
`

export const EcosystemHeaderSubText = styled.div`
  font-size: 12px;
  line-height: 16px;
  font-weight: 400;
  margin-right: 8px;
  color: ${(p) => {
    return p.active ? '#0AA1F4' : 'rgba(32, 32, 32, 0.7)'
  }};

  :hover {
    color: #0AA1F4;
  }
`

export const EcosystemHeaderNavbarDivider = styled.div`
  height: 24px;
  width: 1px;
  background: rgba(32, 32, 32, 0.1);
  margin: 0 12px;
`

export const RemoveItemModalText = styled.div`
  font-size: 16px;
  line-height: 24px;
`

export const RemoveItemModalFooter = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;

  button:first-of-type {
    margin-right: 16px;
  }
`

export const EcoSystemValidationIcon = styled.div`
  position: absolute;
`

export const EcosystemValidationIconWrapper = styled.div`
  position: relative;
  left: 16px;
`

export const EcosystemConfirmDeclineIcon = styled.div`
  margin-right: 24px;
  height: 24px;
  width: 24px;
  display: grid;
  place-items: center;
  border-radius: 50%;
  ${iconType}
`

export const EcosystemsCancelIconWrapper = styled.div`
  height: 32px;
  width: 32px;
  border-radius: 4px;
  display: grid;
  place-items: center;
  user-select: none;
  cursor: pointer;
  margin-left: 16px;

  :hover {
    background: rgba(225, 25, 0, 0.05);

    path {
      fill-opacity: 1;
      fill: rgba(225, 25, 0, 1);
    }
  }
`

export const EcosystemCalendarIconWrapper = styled.div`
  height: 24px;
  width: 24px;
  display: grid;
  place-items: center;
  margin-right: 8px;
`

export const EcosystemCalendarDivider = styled.div`
  height: 24px;
  width: 1px;
  background: rgba(32, 32, 32, 0.1);
  margin: 0 24px;
`

export const EcosystemCalendarDateText = styled.div`
  color: rgba(32, 32, 32, 0.7);
  font-size: 12px;
  line-height: 16px;
  font-weight: 400;
  border-bottom: 1px dotted rgba(32, 32, 32, 0.5);

`

export const EcosystemLastReassessmentCalendarWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`

export const EcosystemContentFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-bottom: 64px;
`

export const EcosystemActionMenuWrapper = styled.div`
  margin-left: 8px;
`

export const EcosystemToggleWrapper = styled.div`
  display: flex;
  align-items: center;
  font-size: 14px;
  font-weight: 400;
  line-height: 16px;
  color: ${(p) => {
    return p.isActive ? 'rgba(10, 161, 244, 1)' : 'rgba(32, 32, 32, 0.7)'
  }};
  gap: 8px;

  path {
    fill: ${(p) => {
    return p.isActive ? 'rgba(10, 161, 244, 1)' : 'rgba(32, 32, 32)'
  }};
    fill-opacity: ${(p) => {
    return p.isActive ? '1' : '0.5'
  }};
  }

  :hover {
    color: rgba(10, 161, 244, 1);

    path {
      fill-opacity: 1;
      fill: rgba(10, 161, 244, 1);
    }
  }
`

export const EcosystemListTitle = styled.div`
  font-size: 16px;
  line-height: 24px;
  font-weight: 400;
  text-align: center;
  margin-bottom: 32px;
  color: rgba(32, 32, 32, 0.7);
  border-bottom: 1px dotted rgba(32, 32, 32, 0.7);
  margin-top: ${(p) => {
    return p.marginTop
  }};
`
export const EcosystemListTitleWrapper = styled.div`
  margin-top: ${(p) => {
    return p.addMarginTop ? '64px' : '0'
  }};
  width: 100%;
  display: flex;
  justify-content: center;
`
export const AddNewThreatsButton = styled.div`
  width: 100%;
  height: 62px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-top: 1px solid #00aaff;
  border-bottom: 1px solid #00aaff;
  margin-top: 64px;
  color: #0aa1f4;
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  pointer-events: ${(p) => {
    return p.disabled ? 'none' : ''
  }};

  > svg {
    margin-right: 8px;
  }

  path {
    fill: #0aa1f4;
  }
`

export const ThreatRemoveIconWrapper = styled.div`
  height: 32px;
  width: 32px;
  border-radius: 4px;
  display: grid;
  place-items: center;
  user-select: none;

  cursor: ${({ isDisabled }) => (isDisabled ? 'not-allowed' : 'pointer')};
  opacity: ${({ isDisabled }) => (isDisabled ? 0.5 : 1)};

  :hover {
    ${({ isDisabled }) =>
      !isDisabled &&
      `
      path {
        fill-opacity: 1;
        fill: rgba(225, 25, 0, 1);
      }
    `}
  }
`

export const ThreatToggleWrapper = styled.div`
  display: flex;
  align-items: center;
  font-size: 14px;
  font-weight: 400;
  line-height: 16px;
  color: ${(p) => {
    return p.isActive ? 'rgba(10, 161, 244, 1)' : 'rgba(32, 32, 32, 0.7)'
  }};
  gap: 8px;

  path {
    fill: ${(p) => {
    return p.isActive ? 'rgba(10, 161, 244, 1)' : 'rgba(32, 32, 32)'
  }};
    fill-opacity: ${(p) => {
    return p.isActive ? '1' : '0.5'
  }};
  }

  :hover {
    color: rgba(10, 161, 244, 1);

    path {
      fill-opacity: 1;
      fill: rgba(10, 161, 244, 1);
    }
  }
`

export const AssessmentPageTittleWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin-top: ${(p) => {
    return p.firstTitle ? '168px' : '96px'
  }};
  margin-bottom: ${(p) => {
    return p.marginBottom? p.marginBottom : '0px'
  }};
`

export const AssessmentPageTittle = styled.div`
  line-height: 32px;
  font-size: 20px;
  font-weight: 600;
  text-align: center;
  margin-bottom: 8px;
`

export const AssessmentPageSubTittle = styled.div`
  line-height: 24px;
  font-size: 16px;
  font-weight: 400;
  border-bottom: 2px dotted rgba(32, 32, 32, 0.5);
`

export const AssessmentPageSubTittleWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: ${(p) => {
    return p.marginBottom
  }};
`

export const AssessmentPageSubTittleIconWrapper = styled.div`
  height: 24px;
  width: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 12px;
`

export const ValidationDiv = styled.div`
  position: absolute;
  top: 15%;
  right: -10%;
`